import { useState, useEffect, useRef } from "react";
import { Formik, Form, FormikProps, Field } from "formik";
// Chakra imports
import {
  Flex,
  Heading,
  useColorModeValue,
  Radio,
  RadioGroup,
  Stack,
} from "@chakra-ui/react";
import { NationalCodeValidation } from "../../../utils/validation";
import Logo from "../../../assets/img/Logo.svg";
import Vezarat from "../../../assets/img/amoozesh-logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import Header from "common/components/Header/Header";
import Datepicker from "../../../common/components/DatePicker/Datepicker";
import { FormikInjectedDropDown } from "../../public/components/landing/FormikInjectedDropDown";
import { GiveValuestoFormComponent } from "common/components/GiveValuestoFormComponent";
import education from "../../../assets/JSON/education.json";
import { MediumBtn } from "common/components/Buttons/MediumBtn";
import { useRegisterMutation } from "../../../api/auth.api";
import { ajaxErrorAlert, ajaxSuccessAlert } from "utils/alert";
import type { Value } from "react-multi-date-picker";

import English from "react-date-object/locales/gregorian_en";
import gregorian from "react-date-object/calendars/gregorian";

// import { IRegister } from "../types/auth/IAuth";

function SignUp() {
  const formRef = useRef<any>(null);
  const textColor = useColorModeValue("rgb(97, 97, 97)", "white");
  const [edu, setEdu] = useState([{ id: 0, label: "" }]);
  const [register, response] = useRegisterMutation();

  const [value, setValue] = useState(new Date());
  const isoDate = new Date(value).toISOString();
  const navigate = useNavigate();
  const initialValues = {
    firstName: "",
    lastName: "",
    nationalId: "",
    dateOfBirth: "",
    gender: "",
    educationLicense: "",
    secondaryPhoneNumber: "",
    address: "",
  };
  console.log("value", isoDate);

  const [formValues, setformValues] = useState(initialValues);
  const valueArray = Object.values(formValues);
  valueArray.reduce((pre, cur) => pre && cur);
  let allFieldsfilled = !!valueArray.reduce((pre, cur) => {
    return pre && cur;
  });

  useEffect(() => {
    setEdu(education.map((edu: any) => ({ id: edu.id, label: edu.label })));
  }, []);

  const isError = NationalCodeValidation(formValues.nationalId);

  const clickHandler = async () => {
    const currectFormatData = {
      ...formValues,
      educationLicense: +formValues.educationLicense,
    };
    await register(currectFormatData)
      .unwrap()
      .then((res: any) => {
        ajaxSuccessAlert("ثبت نام موفقیت آمیز بود");
        navigate("/landing/form");
      })
      .catch((error) => {
        if (error.data.statusCode === 400) {
          ajaxErrorAlert("کاربر گرامی ثبت نام شما انجام شده لطفا وارد شوید");
        } else {
          ajaxErrorAlert("خطایی رخ داده است");
        }
      });
  };

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      style={{ userSelect: "none" }}
      w={{ md: "50%", lg: "40%", sm: "80%" }}
      mb={{ "2xl": "40px" }}
      mt={{
        base: "60px",
        "2xl": "60px",
        xl: "0",
        md: "60px",
        sm: "40px",
      }}
      className="signUpCard"
    >
      <Flex
        direction="column"
        w="100%"
        background="transparent"
        p={{ base: "30px", sm: "30px", md: "30px", lg: "20px", xl: "20px" }}
      >
        <Flex
          direction="column"
          alignItems="center"
          justifyContent="center"
          className="header"
          mb="40px"
        >
          <img src={Logo} className="header-logo" />
          <img src={Vezarat} className="logo-text" />
        </Flex>

        <Flex justifyContent="center">
          <Heading
            color={textColor}
            fontSize={{ base: "30px", xl: "30px", "2xl": "30px", sm: "20px" }}
            mb="40px"
          >
            ثبت نام در سامانه
          </Heading>
        </Flex>

        <Formik
          initialValues={initialValues}
          innerRef={formRef}
          onSubmit={(values) => {
            console.log("Formik values", values);
          }}
        >
          {(props: FormikProps<any>) => (
            <Form onChange={props.handleChange}>
              <GiveValuestoFormComponent setformValues={setformValues} />
              <Field
                name="firstName"
                placeholder="نام"
                type="text"
                className="signUp-input"
              />
              <Field
                name="lastName"
                placeholder="نام خانوادگی"
                type="text"
                className="signUp-input"
              />
              <Field
                validate={NationalCodeValidation}
                name="nationalId"
                placeholder="کد ملی"
                type="text"
                className={`signUp-input ${
                  isError ? "signUp-input" : "signinInput-error"
                }`}
              />

              <Flex justifyContent="space-between" mt="10px">
                <Flex
                  ml={{ base: "5px", sm: "10px", md: "10px", lg: 0, xl: 0 }}
                >
                  <Datepicker value={formValues.dateOfBirth} />
                </Flex>
                <FormikInjectedDropDown
                  btnTxt="مدرک تحصیلی"
                  items={edu}
                  name="educationLicense"
                  value={formValues.educationLicense}
                />
              </Flex>

              <Flex mt="10px" mb="10px" justifyContent="space-between">
                <span>جنسیت خود را انتخاب کنید :</span>

                <RadioGroup name="gender">
                  <Stack spacing={4} direction="row">
                    <Radio value="female">زن</Radio>
                    <Radio value="male">مرد</Radio>
                  </Stack>
                </RadioGroup>
              </Flex>

              <Field
                name="secondaryPhoneNumber"
                placeholder="شماره تماس"
                type="text"
                className="signUp-input"
              />
              <Field
                name="address"
                placeholder="آدرس"
                type="text"
                className="signUp-input"
              />
              <Flex justifyContent="space-between" mt="20px">
                {/* <NavLink to="/admin/dashboard"> */}
                <MediumBtn
                  onClick={clickHandler}
                  fontSize="15px"
                  type="submit"
                  bg="teal.300"
                  w={{ xl: "150px", "2xl": "150px", sm: "100px" }}
                  h="45"
                  mb="20px"
                  color="white"
                  mt="20px"
                  _hover={{
                    bg: "teal.200",
                  }}
                  _active={{
                    bg: "teal.400",
                  }}
                  _disabled={{
                    bg: "teal.100",
                  }}
                  isDisabled={allFieldsfilled ? false : true}
                >
                  ثبت
                </MediumBtn>
                {/* </NavLink> */}

                <NavLink to="/landing">
                  <MediumBtn
                    fontSize="15px"
                    type="submit"
                    bg="red.400"
                    _hover={{
                      bg: "red.500",
                    }}
                    _active={{
                      bg: "red.600",
                    }}
                    w={{ xl: "150px", "2xl": "150px", sm: "100px" }}
                    h="45"
                    mb="20px"
                    color="white"
                    mt="20px"
                  >
                    انصراف
                  </MediumBtn>
                </NavLink>
              </Flex>
            </Form>
          )}
        </Formik>
      </Flex>
    </Flex>
  );
}

export default SignUp;
